<template>
<div class="chapter">
<div class="inner_page">
<div class="galley-rw">
<section class="frontmatter-rw BookTitlePage-rw" epub:type="frontmatter titlepage" id="BookTitlePage1">
<div class="title-block-book-rw" id="title-block-book1">
<h1 epub:type="fulltitle" id="h13">A Midnight Clear</h1>
<p class="title-author-rw" id="title-author1">Hope Ramsay</p>
</div>
<div class="imprint-rw" epub:type="imprint"><img alt="alt" height="98" src="images/ForeverYours_eLogo.png" width="98"/><p id="p2">New York Boston</p>
</div>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// s001-BookTitlePage-01.vue?5e86fbb0